import { parseAsArrayOf, parseAsString, useQueryStates } from "nuqs";
import { Classification } from "@/src/models/constants/classifications";
import { LabResults } from "@/src/models/documents/lab-results/lab-results";

/** Table row shape: the LabResults model plus the section classification the row came from. */
export interface LabResultsWithClassification extends LabResults {
  classification: Classification;
}
export const labResultsQueryParams = {
  labResultsClassification: parseAsArrayOf(parseAsString, ","),
  typeOfLab: parseAsArrayOf(parseAsString, ","),
  needsSignature: parseAsArrayOf(parseAsString, ",")
};
export function useLabResultsColumnFilters() {
  return useQueryStates(labResultsQueryParams);
}